import axios from 'axios'

export default {
    getCategories() {
        return axios.get(`/api/complaintcodes/categories`);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/shared/components/categoryselector/api.js